const { pageWrapper } = require(`~common/utils/root`)
const { initializeAnalytics, trackPageView } = require(`./src/analytics`)

export const wrapPageElement = pageWrapper

export const onClientEntry = () => {
  initializeAnalytics()
}

export const onRouteUpdate = ({ location }) => {
  trackPageView(location)
}
